export const composeMapper = () => (originalMapper, { add, remove, }, mapperFunc) => {
    const originalDeps = remove
        ? Object.keys(originalMapper.deps).filter(dependency => !remove.includes(dependency))
        : Object.keys(originalMapper.deps);
    const mergedDeps = add ? originalDeps.concat(add) : originalDeps;
    const deps = mergedDeps.reduce((acc, key) => ({ ...acc, [key]: true }), {});
    const resolver = (data, carmiData) => mapperFunc(originalMapper.resolver, data, carmiData);
    return {
        deps,
        resolver,
    };
};
//# sourceMappingURL=composeMapper.js.map